import { useEvent } from "../../../../data/hooks/eventHooks";
import { useScheduleAndMeetings } from "../useScheduleAndMeetings";
import { useDatesFromItems } from "../../../../data/hooks/datetime/useDatesFromItems";
import { useNextBestDate } from "../../../../data/hooks/datetime/useNextBestDate";

export function useDefaultScheduleDate(eventId) {
    const event = useEvent(eventId),
        eventScheduleWithMeetings = useScheduleAndMeetings(eventId),
        dates = useDatesFromItems(event, eventScheduleWithMeetings),
        defaultDate = useNextBestDate(event, dates);

    return defaultDate;
}
